import axios from "axios";
import { NOTIFICATIONS_ENDPOINTS } from "./notificationsConstants";

/**
 * Fetches the admin incident notifications.
 * @param {Object} params - { unread, page, pageSize }
 * @returns {Promise<Object>} { items, unread, total, page, page_size }
 */
export async function fetchAdminNotifications({ unread = false, page = 1, pageSize = 20 } = {}) {
    const { data } = await axios.get(NOTIFICATIONS_ENDPOINTS.list, {
        params: { unread: unread ? "true" : undefined, page, page_size: pageSize },
    });
    return data;
}

/**
 * Marks a single notification as read.
 * @param {number} notificationId - Notification primary key
 * @returns {Promise<Object>} The updated notification
 */
export async function markNotificationRead(notificationId) {
    const { data } = await axios.put(NOTIFICATIONS_ENDPOINTS.read(notificationId));
    return data;
}

/**
 * Marks every unread notification of the current admin as read.
 * @returns {Promise<Object>} { marked }
 */
export async function markAllNotificationsRead() {
    const { data } = await axios.put(NOTIFICATIONS_ENDPOINTS.readAll);
    return data;
}
